import React from 'react';
import PropTypes from 'prop-types';
import MaterialTable from 'material-table';

import { useTranslation } from 'react-i18next';

// style
import tableIcons from '../../../../components/table/MaterialTableIcon';

// Utils
import exportCsv from '../../../../utils/export/Csv';

export default function DroughtDetailList(props) {
  const { t } = useTranslation();
  const { datas, userIsLogin } = props;
  const isExport = (userIsLogin) ? { csv: true } : userIsLogin;

  return (
    <>
      <MaterialTable
        icons={tableIcons}
        columns={[
          {
            title: t('จังหวัด'),
            title_export: t('จังหวัด'),
            field: 'province_name',
            type: 'date',
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            render: (row) => `${row.province_name}`,
          },
          {
            title: t('วันที่'),
            title_export: t('วันที่'),
            field: 'date',
            type: 'string',
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            render: (row) => `${row.date}`,
          },
          {
            title: t('เวลา'),
            title_export: t('เวลา'),
            field: 'time',
            type: 'time',
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            render: (row) => `${row.time.substring(0, 5)} น.`,
          },
          {
            title: t('ปริมาณฝนสะสม 15 วันย้อนหลัง (มม.)'),
            title_export: t('ปริมาณฝนสะสม 15 วันย้อนหลัง (มม.)'),
            field: 'rfhistorical',
            type: 'number',
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            render: (row) => `${row.rfhistorical}`,
          },
          {
            title: t('ปริมาณฝนสะสมคาดการณ์ล่วงหน้า 7 วัน (มม.)'),
            title_export: 'forcast',
            field: 'rfforcast',
            type: 'number',
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            render: (row) => `${row.rfforcast}`,
          },
        ]}
        data={datas}
        localization={{
          pagination: {
            labelRowsSelect: t('แถว'),
          },
          body: { emptyDataSourceMessage: <h3>{t('ไม่มีข้อมูลตามเงื่อนไข')}</h3> },
        }}
        options={{
          tableLayout: 'fixed',
          pageSize: 5,
          sorting: true,
          search: false,
          rowStyle: {
            wordWrap: 'break-word',
          },
          showTitle: false,
          toolbar: isExport,
          exportButton: isExport,
          exportCsv,
        }}
        style={{ boxShadow: 'none' }}
      />
    </>
  );
}

DroughtDetailList.propTypes = {
  datas: PropTypes.instanceOf(Array).isRequired,
  userIsLogin: PropTypes.bool.isRequired,
};
